import {connect} from 'react-redux';
import {Component} from 'react';
import classNames from 'classnames';
import injectSheet from 'react-jss';

import Modal from '-/components/general/Modal';
import SSNInput from '-/components/fields/SSNInput';
import {authenticate} from '-/util/authenticate';
import FunnelService from '-/services/FunnelService';
import validationStyles from '-/styles/sections/validation';

const styles = theme => ({
    ...validationStyles(theme)
});

class VerifySSN extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formError: '',
            showErrorMsg: false,
            lastFour: ''
        };
    }

    handleSSNChange = e => {
        this.setState({
            lastFour: e
        });
    };

    componentWillReceiveProps(nextProps) {
        if (typeof nextProps.validated === 'boolean') {
            this.setState({showErrorMsg: !nextProps.validated});
        }
    }

    // How far the member got if they leave this screen without authenticating. This is
    // the only place abandonment inside the auth step is visible - a character count,
    // never the value.
    componentWillUnmount() {
        if (this.props.validated === true) {
            return;
        }

        FunnelService.authFieldProgress('ssn', 'ssn', this.state.lastFour);
    }

    handleSubmit = () => {
        const {authenticate} = this.props;
        const {lastFour} = this.state;
        let formError;

        if (lastFour.length !== 4) {
            formError = 'You must provide the last 4 digits of your SSN';
            FunnelService.authFieldProgress('ssn', 'ssn', lastFour);
        } else {
            authenticate('ssn', lastFour);
        }

        this.setState({
            formError
        });
    };

    handleKeyDown = e => {
        if (e.keyCode === 13) {
            this.handleSubmit();
        }
    };

    render() {
        const {validated, classes = {}} = this.props;
        const {formError, lastFour, showErrorMsg} = this.state;

        const checkClassNames = classNames(classes.verifyIcon, {
            [classes.verifyIconSuccess]: validated === true,
            [classes.verifyIconFail]: validated === false
        });

        return (
            <Modal className="verify-ssn" onClick={this.handleSubmit}>
                <section className={classes.description}>
                    <div className={classes.icon}>
                        <i className="fa fa-shield" alt="Shield" />
                        {validated !== null ? <span className={checkClassNames} /> : null}
                    </div>
                    <div className={classes.text}>
                        <h3>Verify Social Security Number</h3>
                        {formError && <h4 className={classes.errorText}>{formError}</h4>}
                        {showErrorMsg ? (
                            <h4 className={classes.errorText}>The last 4 digits of your social security number doesn’t match what we have on file</h4>
                        ) : null}
                    </div>
                </section>
                <div className="masked-form">
                    <div className="control">
                        <SSNInput
                            value={lastFour}
                            onChange={this.handleSSNChange}
                            onKeyDown={this.handleKeyDown}
                            part="last4" />
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    const {validated} = state.validationInfo;
    return {validated};
};

export default connect(mapStateToProps, {authenticate})(injectSheet(styles)(VerifySSN));
